export enum AnnouncementType {
  COMPANY_MSG = 'COMPANY_MSG',
  MEETING = 'MEETING',
  EVENT = 'EVENT',
  OTHER = 'OTHER',
}
